import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { TYPE_PDF_EXCEL } from 'domain/models';
import { HandleReportsAnalyticalActivitiesByStudent } from 'domain/usecases';

export class RemoteHandleReportsAnalyticalActivitiesByStudent
  implements HandleReportsAnalyticalActivitiesByStudent
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleReportsAnalyticalActivitiesByStudent.Result>,
  ) {}

  async execute(
    params: HandleReportsAnalyticalActivitiesByStudent.Params,
  ): Promise<HandleReportsAnalyticalActivitiesByStudent.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type === undefined ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
